export default __webpack_public_path__ + "static/logo-8f4de7340149153bc771137e4f1f6f26.png";